import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=be70b5d2&scoped=true"
import script from "./Print.vue?vue&type=script&lang=js"
export * from "./Print.vue?vue&type=script&lang=js"
import style0 from "./Print.vue?vue&type=style&index=0&id=be70b5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be70b5d2",
  null
  
)

export default component.exports